export default __webpack_public_path__ + "static/BitterSemiBold-d4944ac1404aea3a22437c690c5a7cad.ttf";